import React from 'react'
import { Head, Header, UpdateForm } from './components'

const UpdateTeacher = () => {
	return (
		<div className='sm:p-6 p-3'>
			<Head />
			<Header />
			<UpdateForm />
		</div>
	)
}

export default UpdateTeacher
